import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { TGRUpdateFreespinsCountsInBetBar } from "commands/tgr-update-freespins-count-in-betbar";
import { TGRMatrixComponent } from "components/tgr-matrix";
import { EpicUIColourComponent } from "epic/components/epic-ui-colour-component";
import { gameLayers } from "game-layers";
import { gamevy } from "gamevy/gamevy";
import { PartnerConnectEvents } from "partner-connect/partner-connect-events";
import { PartnerConnectInit } from "partner-connect/states/partner-connect-init";
import { TGRSetupPartnerConnect } from "setup/tgr-setup-partner-connect";
import { UpdateRandomMultipliersOnReelsets } from "tgr-utils";

export class TGRInit extends PartnerConnectInit {

    public onExit(): void {
        super.onExit();
        TGRSetupPartnerConnect();
        UpdateRandomMultipliersOnReelsets();
        Services.bet.onBetChange.add(() => UpdateRandomMultipliersOnReelsets());
        Components.get(TGRMatrixComponent).darkenReels(false, 0).execute();
        Components.get(EpicUIColourComponent).setInitialAdjustment(210, 2, 1);
        gameLayers.SymbolAnimations.enableBoundsMask(true);
    }

    protected startGame(): Contract<any> {
        gamevy.preloadingFinished();

        PartnerConnectEvents.onBalanceChanged.add(() => Services.transaction.setBalance(gameState.getCurrentGame().balance));

        Services.transaction.currentWinUpdate.add((value: number) => TGRUpdateFreespinsCountsInBetBar());
        Services.transaction.totalWinUpdate.add((value: number) => TGRUpdateFreespinsCountsInBetBar());
        Services.transaction.balanceUpdate.add((value: number) => TGRUpdateFreespinsCountsInBetBar());

        gameLayers.BetBar.onSceneEnter.add(() => {
            if (gameLayers.BetBar.elements?.active?.balance_value) {
                gameLayers.BetBar.elements.active.balance_value.style.wordWrap = false;
            }
        });

        return super.startGame();
    }
}
